<template>
	<div class="right_content_container">
		<div class="flex_between">
			<div class="left_title">快捷回复</div>
			<div v-throttle="addGroup" class="add_btn flex_center">
				<p style="margin-top: -2px">+&nbsp;</p>
				<p>添加分组</p>
			</div>
		</div>

		<div v-if="quickreply.length > 0 || showAddGroup" class="table_plate">
			<div v-if="showAddGroup">
				<el-input
					style="height: 54px; width: 386px; margin-right: 20px"
					v-model="groupNameVal"
					:maxlength="30"
					show-word-limit
					placeholder="请输入分组名称"
				/>
				<el-button type="primary" class="save_button" v-throttle="addEditGroup">保存</el-button>
			</div>
			<div
				v-for="(item, index) in quickreply"
				:key="item.id"
				:style="{ marginTop: index === 0 && !showAddGroup ? '0' : '20px' }"
			>
				<div
					v-if="editGroupId === item.id && editGroupName"
					class="flex_center"
					style="justify-content: flex-start"
				>
					<el-input
						style="height: 54px; width: 386px; margin-right: 20px"
						v-model="groupNameVal"
						:maxlength="30"
						show-word-limit
						placeholder="请输入分组名称"
					/>
					<el-button type="primary" class="save_button" v-throttle="addEditGroup">保存</el-button>
				</div>
				<div v-else class="flex_center" style="justify-content: flex-start">
					<div class="group_item flex_between">
						<div
							class="flex_center"
							style="justify-content: flex-start; flex: 1; cursor: pointer"
							@click="showGroupFn(item)"
						>
							<img
								style="width: 16px; height: 16px"
								:class="
									quickreplyIndex.indexOf(item.id) > -1 &&
									item.replyList.length > 0 &&
									'show_down_icon'
								"
								src="../assets/right_icon.png"
							/>
							<span>{{ item.groupName }}</span>
							<span>（{{ item.replyList.length > 0 ? item.replyList.length : 0 }}）</span>
						</div>
						<el-button type="success" class="green_add_button" @click="showAddDialog(item)"
							>新增</el-button
						>
					</div>
					<el-button type="primary" @click="deleteEditGroup('edit', item)">编辑</el-button>
					<el-dropdown
						class="group_delete"
						:disabled="	quickreplyIndex.indexOf(item.id) > -1 &&
									item.replyList.length > 0"
					>
						<div class="el-dropdown-link">
							排序
						</div>
						<template #dropdown>
							<el-dropdown-menu>
								<el-dropdown-item :disabled="index === 0" @click="moveItem(index, -1)">
									上移
								</el-dropdown-item>
								<el-dropdown-item
									:disabled="index === quickreply.length - 1"
									@click="moveItem(index, 1)"
								>
									下移
								</el-dropdown-item>
							</el-dropdown-menu>
						</template>
					</el-dropdown>
					<span class="group_delete" v-throttle="() => deleteEditGroup('delete', item)">删除</span>
				</div>

				<!-- 快捷回复 -->
				<div v-if="quickreplyIndex.indexOf(item.id) > -1 && item.replyList.length > 0">
					<div class="group_data_title flex_center" style="justify-content: flex-start">
						<p>问题</p>
						<p>关键词</p>
						<p>回答</p>
						<span class="group_delete" style="opacity: 0">编辑</span>
						<span class="group_delete" style="opacity: 0">删除</span>
					</div>
					<div
						v-for="(its, tsIndex) in item.replyList"
						:key="its.id"
						class="group_data_title flex_center"
						style="justify-content: flex-start; margin-bottom: 20px; align-items: flex-start"
					>
						<div style="display: flex; flex: 1">
							<div class="item_border">{{ its.title }}</div>
							<div class="item_border">
								<span v-for="(itsList, tsIndex) in its.replyKeywordList" :key="tsIndex">
									{{ itsList.keyword }}&nbsp;
								</span>
							</div>
							<div class="item_border" v-html="its.content"></div>
						</div>
						<el-button type="primary" @click="deleteEditReply('edit', its)">编辑</el-button>
						<el-dropdown class="group_delete">
							<div class="el-dropdown-link" style="margin-top: 3px;">
								排序
							</div>
							<template #dropdown>
								<el-dropdown-menu>
									<el-dropdown-item :disabled="tsIndex === 0" @click="moveItemTwo(tsIndex, -1,index)">
										上移
									</el-dropdown-item>
									<el-dropdown-item
										:disabled="tsIndex === item.replyList.length - 1"
										@click="moveItemTwo(tsIndex, 1,index)"
									>
										下移
									</el-dropdown-item>
								</el-dropdown-menu>
							</template>
						</el-dropdown>
						<span class="group_delete" v-throttle="() => deleteEditReply('delete', its)">删除</span>
					</div>
				</div>
			</div>
		</div>

		<div v-else class="global_none_data">
			<div class="flex_center">
				<img src="../assets/none_thing/none_answer_image.png" />
			</div>
			<p>暂无问答</p>
		</div>

		<el-dialog
			v-model="centerDialogVisible"
			title=""
			:close-on-click-modal="false"
			:show-close="false"
			center
			style="padding: 40px; padding-bottom: 20px"
		>
			<template #header>
				<p class="dialog_title">{{ dialogTitle }}</p>
			</template>
			<div class="dialog_content">
				<p class="label_name">标题</p>
				<el-input
					v-model="textarea"
					style="width: 60%"
					:rows="3"
					type="textarea"
					placeholder="请输入标题"
					:maxlength="100"
					@blur="checkoutValue"
					show-word-limit
				/>
			</div>
			<div class="dialog_content" style="margin-top: 20px">
				<p class="label_name">内容</p>
				<!-- <div style="flex: 1" v-if="dialogTitle=='新增快捷回复'">
					<QuillEditor
						v-if="centerDialogVisible"
						:messageContent="getEditorContent"
						:content="context"
					/>
				</div> -->
				<div	style="flex: 1" >
					<textarea 
					placeholder="请输入内容"
					v-model="context"
					maxlength="1000"
					class="inputTextarea"
					>

					</textarea>
				</div>
			</div>
			<div class="dialog_content" style="margin-top: 20px; margin-bottom: 5px; align-items: center">
				<p class="label_name" style="margin-right: 10px; margin-top: 5px">关键词</p>
				<div style="display: flex; align-items: center; flex-flow: row wrap; flex: 1">
					<div
						v-for="(keyData, index) in keywordArray"
						:key="index"
						style="margin-left: 10px; margin-top: 5px"
					>
						<el-input
							v-model="keyData.value"
							style="width: 95px"
							:rows="3"
							type="text"
							placeholder="添加关键词"
							@blur="checkoutValue"
							clearable
						/>
					</div>
					<el-button
						type="primary"
						style="margin-left: 10px; margin-top: 5px; font-size: 18px"
						@click="addKey"
						>+</el-button
					>
				</div>
			</div>
			<template #footer>
				<div class="dialog-footer">
					<el-button @click="centerDialogVisible = false">取消</el-button>
					<el-button type="primary" v-throttle="saveData"> 保存 </el-button>
				</div>
			</template>
		</el-dialog>
	</div>
</template>

<script setup>
import { ref, onMounted, getCurrentInstance } from "vue";
import { post, get, deleteRe, put } from "../utils/request";
import QuillEditor from "./quill_editor.vue";
import { message } from "../utils/resetMessage";
const { proxy } = getCurrentInstance();
const centerDialogVisible = ref(false);

const textarea = ref("");
const context = ref("");
const quickreply = ref([]);
const showDataId = ref("");
const showAddGroup = ref(false);
const groupNameVal = ref("");
const editGroupId = ref("");
const editGroupName = ref(false);
const keywordArray = ref([
	{
		value: "",
	},
]);
const reArray = ref([]);
const editreplyId = ref("");
const quickreplyIndex = ref([]);
const dialogTitle = ref("新增快捷回复");
onMounted(() => {
	getGroup();
});

const checkoutValue = () => {
	if (textarea.value) {
		textarea.value = textarea.value.replace(/^\s+|\s+$/g, "");
	}
};
const moveItem = (index, direction) => {
	const list = JSON.parse(JSON.stringify(quickreply.value)); // 或从参数、闭包中获取
	const targetIndex = index + direction;
	[list[index], list[targetIndex]] = [list[targetIndex], list[index]];
	const idList = list.map((item) => item.id);
	post("/api-cms/reply/group/turn", { idList })
		.then((res) => {
			if (res.code === 1) {
				getGroup();
			} else {
				message.error("排序更新失败");
			}
		})
		.catch((error) => {
			message.error("排序更新失败");
		});
};
const moveItemTwo = (index, direction, groupIndex) => {
	const listTwo = JSON.parse(JSON.stringify(quickreply.value[groupIndex].replyList)); // 或从参数、闭包中获取
	const targetIndexs = index + direction;
	[listTwo[index], listTwo[targetIndexs]] = [listTwo[targetIndexs], listTwo[index]];
	const idList = listTwo.map((item) => item.id);
	post("/api-cms/reply/turn", { idList })
		.then((res) => {
			if (res.code === 1) {
				getGroup();
			} else {
				message.error("排序更新失败");
			}
		})
		.catch((error) => {
			message.error("排序更新失败");
		});
};
// 显示富文本编辑弹窗
const showAddDialog = (data) => {
	textarea.value = "";
	context.value = "";
	keywordArray.value = [
		{
			value: "",
		},
	];
	editreplyId.value = "";
	showDataId.value = data.id;
	dialogTitle.value = "新增快捷回复";
	centerDialogVisible.value = true;
};

const getEditorContent = (item) => {
	context.value = item;
};

// 展开/关闭分组
const showGroupFn = (data) => {
	showDataId.value = data.id;
	if (data.replyList.length > 0) {
		if (quickreplyIndex.value.indexOf(data.id) > -1) {
			quickreplyIndex.value = quickreplyIndex.value.filter((id) => {
				return id !== data.id;
			});
		} else {
			quickreplyIndex.value = [];
			quickreplyIndex.value.push(data.id);
		}
	}
};

// 获取分组
const getGroup = () => {
	get("/api-cms/reply/group", {})
		.then((res) => {
			// console.log(res);
			if (res.code === 1) {
				quickreply.value = res.result;
			}
		})
		.catch((error) => {
			console.log(error);
		});
};

// 删除/编辑快捷分组
const deleteEditGroup = (type, data) => {
	if (type === "edit") {
		groupNameVal.value = data.groupName;
		editGroupId.value = data.id;
		editGroupName.value = true;
	} else {
		if (data.replyList.length > 0) {
			proxy.$confirm("是否删除该分组下的所有快捷回复？", "提示", {
				confirmButtonText: "删除",
				cancelButtonText: "取消",
				center: true,
				showClose: false,
				closeOnClickModal: false,
				closeOnPressEscape: false,
				callback: (type) => {
					if (type === "confirm") {
						deleteGroup(data.id);
					}
				},
			});
		} else {
			deleteGroup(data.id);
		}
	}
};

// 新增/编辑快捷分组
const addEditGroup = () => {
	let reg = /^[^\s]+[\s]*.*$/;
	if (!groupNameVal.value) {
		proxy.$message({
			message: "请输入分组名称",
			type: "error",
		});

		return;
	}
	if (!reg.test(groupNameVal.value)) {
		groupNameVal.value = "";
		return;
	}
	let params;
	if (editGroupId.value) {
		params = {
			id: editGroupId.value,
			groupName: groupNameVal.value,
		};
	} else {
		params = {
			groupName: groupNameVal.value,
		};
	}
	post("/api-cms/reply/group", params)
		.then((res) => {
			// console.log(res);
			if (res.code === 1) {
				centerDialogVisible.value = false;
				message.success("保存成功");
				showAddGroup.value = false;
				groupNameVal.value = "";
				editGroupId.value = "";
				editGroupName.value = false;
				getGroup();
			}
		})
		.catch((error) => {
			console.log(error);
		});
};

// 删除分组
const deleteGroup = (id) => {
	deleteRe("/api-cms/reply/group/" + id, {})
		.then((res) => {
			if (res.code === 1) {
				message.success("删除成功");
				getGroup();
			}
		})
		.catch((error) => {
			console.log(error);
		});
};
const addGroup = () => {
	if (editGroupName.value) {
		message.error("请先保存分组");
	} else {
		showAddGroup.value = true;
	}
};
// 编辑/删除快捷回复
const deleteEditReply = (type, data) => {
	if (type === "edit") {
		dialogTitle.value = "编辑快捷回复";
		textarea.value = data.title;
		context.value = data.content;
		editreplyId.value = data.id;
		if (data.replyKeywordList.length > 0) {
			let newArr = [];
			data.replyKeywordList.forEach((keyData) => {
				let keyValue = {
					value: keyData.keyword,
				};
				newArr.push(keyValue);
			});
			keywordArray.value = newArr;
		}
		centerDialogVisible.value = true;
	} else {
		deleteRe("/api-cms/reply/quick/" + data.id, {})
			.then((res) => {
				if (res.code === 1) {
					message.success("删除成功");
					getGroup();
				}
			})
			.catch((error) => {
				console.log(error);
			});
	}
};

// 新增关键词
const addKey = () => {
	let keyObj = {
		value: "",
	};
	keywordArray.value.push(keyObj);
};

// 输入框为空校验
const saveData = () => {
	if (!textarea.value) {
		proxy.$message({
			message: "请输入标题",
			type: "error",
		});

		return;
	}

	if (!context.value) {
		proxy.$message({
			message: "请输入内容",
			type: "error",
		});

		return;
	}

	reArray.value = [];
	keywordArray.value.forEach((item) => {
		if (item.value) {
			let itemVal = {
				keyword: item.value,
			};
			reArray.value.push(itemVal);
		}
	});

	if (reArray.value.length === 0) {
		proxy.$message({
			message: "关键词不能为空",
			type: "error",
		});

		return;
	}

	addEditReply();
};

// 新增/编辑快捷回复
const addEditReply = () => {
	let params;
	if (editreplyId.value) {
		params = {
			id: editreplyId.value,
			groupId: showDataId.value,
			title: textarea.value,
			content: context.value,
			replyKeywordList: reArray.value,
		};
	} else {
		params = {
			groupId: showDataId.value,
			title: textarea.value,
			content: context.value,
			replyKeywordList: reArray.value,
		};
	}

	// console.log(params);
	post("/api-cms/reply/quick", params)
		.then((res) => {
			console.log(res);
			// proxy.$message.closeAll();
			if (res.code === 1) {
				message.success("保存成功");
				centerDialogVisible.value = false;
				showDataId.value = "";
				getGroup();
			}
		})
		.catch((error) => {
			console.log(error);
		});
};
</script>

<style scoped lang="less">
.dialog_content {
	display: flex;
	align-items: flex-start;
}
.group_item {
	min-width: 364px;
	font-size: 14px;
	padding: 10px;
	border-radius: 4px;
	margin-right: 20px;
	border: 1px #dcdfe6 solid;

	span {
		font-size: 14px;
		color: #606266;
		margin-left: 5px;
	}
}
.group_delete {
	padding: 5px 10px;
	border-radius: 4px;
	font-size: 14px;
	color: #ff4040;
	cursor: pointer;
}
.group_data_title {
	width: 80%;
	margin-top: 10px;
	p {
		flex: 1;
		font-size: 14px;
		color: #000000;
		margin-right: 20px;
	}
	.item_border {
		padding: 5px 10px;
		border-radius: 4px;
		margin-right: 20px;
		position: relative;
		flex: 1;
		word-break: break-all;
		&::after {
			content: "";
			width: 100%;
			height: 100%;
			border-radius: 4px;
			border: 1px #dcdfe6 solid;
			position: absolute;
			top: -1px;
			left: 0;
		}
	}
}
.label_name {
	width: 50px;
	font-size: 14px;
	color: #606266;
	text-align: right;
	margin-right: 20px;
}
.green_add_button {
	&:hover {
		background-color: rgba(129, 212, 128, 0.2) !important;
		border-color: rgba(129, 212, 128, 0.2) !important;
		color: #81d480 !important;
	}
}
.save_button {
	background-color: #5d93ff !important;
	border-color: #5d93ff !important;
	&:hover {
		background-color: rgba(93, 147, 255, 0.2) !important;
		border-color: rgba(93, 147, 255, 0.2) !important;
		color: #5d93ff !important;
	}
}
.show_down_icon {
	transform: rotate(90deg);
	transition: all linear 0.1s;
}
.group_delete .el-dropdown-link {
	cursor: pointer;
	color: #A15BFF;
	display: flex;
	align-items: center;
}
.el-dropdown .el-tooltip__trigger:focus-visible {
	outline: none;
}
.inputTextarea{
	width: 100%;
	height: 100%;
	min-height: 200px;
	border-radius: 4px;
	border: 1px solid #dcdfe6;
	padding: 10px;
	font-size: 14px;
	resize: none;
	outline: none;
	line-height: 20px;
}

</style>
